var map = {
	"./Pandit-Karn_4.jpeg": 17,
	"./Ravi-Karn_7.jpeg": 980,
	"./Rohan-Karn_6.jpeg": 843,
	"./Sanjay-Karn_5.jpeg": 36,
	"./Shashi-Karn_8.png": 308,
	"./Sujay-Lal-Karn_3.jpeg": 902,
	"./Vijay-Lal-Karn_2.jpeg": 500,
	"./Vinay-Lal-Karn_1.jpeg": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;